import { Http, PageData, PageQuery } from '@mygpt/app/http';
import { User } from '@mygpt/app/users/services/get-enterprise-plan-list';

export interface DatasetMembersItem {
  id: string;
  created_at: string;
  resource_id: string;
  resource_type: string;
  member: User;
}

export interface DatasetItemWithMembers {
  dataset: DatasetItemWithMembers;
  members: DatasetMembersItem[];
}

export interface DatasetItemWithMembers {
  id: string;
  name: string;
  description: string;
}
/**
 * 获取知识库列表（带协作者信息）
 * @param params
 * @returns
 */
export const getDatasetListWithMembers = (params: PageQuery) => {
  const { get } = Http.use();
  return get<PageData<DatasetItemWithMembers>>(`/datasets/members`, {
    params,
  });
};
